import { skipToken } from '@reduxjs/toolkit/query';
import { CommanderAPI } from '../CommanderAPI';
import { useAppSelector } from '../../../../redux/store.model';
import { getMyWorkspaceSelector } from '../../../../redux/workspace/selectors/Workspace.selectors';
import { ITypeRequest } from '../../../../theme/ui/Dashboard/Dashboard.model';
import { M_SECONDS_POOLING_INTERVAL_DATA } from '../../../store/Store.constants';

interface IUseAirConnectStatusProps {
  groupId?: string;
  workspaceId?: string;
  typeRequest: ITypeRequest;
}

/**
 * FIXME: This hook is currently the same as useCommanderOfflineCount, but it should be changed to use the correct API endpoint once it's available.
 * The API endpoint for getting the AirConnect status count is currently not implemented, so we are using the same endpoint as CommanderOfflineCount for now.
 * Once the correct API endpoint is implemented, we should update this hook to use that endpoint instead.
 */
function useAirConnectStatus(props: IUseAirConnectStatusProps) {
  const { typeRequest, groupId, workspaceId } = props;

  const userDevicesAirConnectStatusResponse =
    CommanderAPI.useGetAirConnectStatusByUserQuery(undefined, {
      pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
      skip: typeRequest !== 'user',
    });

  const groupDevicesAirConnectStatusResponse =
    CommanderAPI.useGetAirConnectStatusByGroupQuery(groupId ?? skipToken, {
      pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
      skip: typeRequest !== 'group',
    });

  const workspaceDevicesAirConnectStatusResponse =
    CommanderAPI.useGetAirConnectStatusByWorkspaceQuery(
      workspaceId ?? skipToken,
      {
        pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
        skip: typeRequest !== 'workspace',
      }
    );
  const myWorkspace = useAppSelector(getMyWorkspaceSelector);

  const workspacesDevicesAirConnectStatusResponse =
    CommanderAPI.useGetAirConnectStatusByWorkspaceQuery(
      myWorkspace?.id ?? skipToken,
      {
        pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
        skip: typeRequest !== 'workspaces',
      }
    );

  switch (typeRequest) {
    case 'user':
      return userDevicesAirConnectStatusResponse;
    case 'group':
      return groupDevicesAirConnectStatusResponse;
    case 'workspace':
      return workspaceDevicesAirConnectStatusResponse;
    case 'workspaces':
      return workspacesDevicesAirConnectStatusResponse;
    default:
      return userDevicesAirConnectStatusResponse;
  }
}

export default useAirConnectStatus;
